export class ResetProjectApisList {
  public static readonly type = '[Project/Api/List] ResetProjectApisList';
}
